export default function mobileLogin () {
    if(window.webkit){
      window.webkit.messageHandlers.login.postMessage(null)
      window.webkit.messageHandlers.back.postMessage(null) 
    }
    if(window.Android){
      window.Android.login()
    }
}